import { useState } from "react";
import { Card } from "@/components/Shared/Card";
import { ListTable } from "./ListTable";
import { Separator } from "@/components/ui/separator";
import { DateRangePicker } from "@/components/ui/Calendar/datepicker";

export function ListDashboard() {
	const [selectedRange, setSelectedRange] = useState<{
		from: Temporal.PlainDate | undefined;
		to: Temporal.PlainDate | undefined;
	}>({
		from: undefined,
		to: undefined,
	});

	return (
		<Card>
			<h1 className="text-xl font-bold">Listado de Imputaciones</h1>
			<Separator />
			<DateRangePicker value={selectedRange} onChange={setSelectedRange} />
			<ListTable
				filter={{
					range: selectedRange,
				}}
			/>
		</Card>
	);
}
